import { Alert } from "antd";
import styled from "styled-components";
import { background, borders, icons } from "../../../context/helper";
import { CloseOutlined } from "@ant-design/icons";

const MyAlert = ({ type, ...rest }) => <Alert
    {...rest}
    type={type === "progress" ? "info" : type}
    closeIcon={<CloseOutlined style={{ color: "#292929" }} />}
    className={rest.className || ""}
    style={{
        ...rest.style,
        border: borders[type],
        backgroundColor: background[type]
        //transform: `translateY(${-idx * 88}px)`
    }}
    icon={icons[type]}
    />

export const CustomAlert = styled(MyAlert)`

    .ant-alert-message {
        font-weight: 600;
        color: #1f1f1f;
        font-size: 14px;
        line-height: 1.43;
    }

    .ant-alert-description {
        color: #292929;
        font-family: Nunito Sans;
        line-height: 1.43;
        font-size: 14px;
        font-weight: 300;
        overflow: hidden;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    .ant-alert-icon {
        margin-top: 3px;
    }

    .ant-alert-close-icon {
        margin-top: 5px;
    }

    // .ant-alert-content {
    //     transform: translateY(-10px);
    // }
    // .ant-alert-close-icon {
    //     margin-top: -25px;
    // }

    .ant-alert-content {
        overflow: hidden;
        word-wrap: break-word;
        overflow-wrap: break-word;
        min-width: 0;
    }

    .ant-alert-action {
        position: absolute;
        bottom: 13px;
        right: 23px;
        flex-shrink: 0;
    }

    &.guardrail-alert .ant-alert-action {
        position: absolute;
        top: 20px;
        right: 23px;
        bottom: auto;
    }

    /* Scoped tweaks for DNS warning alert only */
    &.dns-warning-alert {
        .ant-alert-message {
            margin-bottom: 5px;
            font-size: 12px;
        }

        .ant-alert-description {
            line-height: 1.25;
            font-size: 11px;
            font-weight: 400;
        }
    }
`;